import AppThemeShell from "../shared/AppThemeShell";
import { useDocumentTitle } from "../shared/useDocumentTitle";
import Prosjektliste from "./Prosjektliste";

function App() {
    useDocumentTitle("Prosjektliste - Kunnskapshuset Enova");

    return (
        <AppThemeShell color="neutral">
            <Prosjektliste />
        </AppThemeShell>
    );
}

export default App;
